import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useSelector } from '@grandvisionhq/state';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getSelectedFrame, getFrameImage } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import { FrameInformation } from './FrameInformation.js';

const FrameInformationContainer = (props)=>{
    const frame = useSelector(getSelectedFrame);
    const imageUrl = useSelector((s)=>{
        var ref;
        return (ref = getFrameImage(s, {
            width: 100
        })) === null || ref === void 0 ? void 0 : ref.url;
    });
    if (!frame) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FrameInformation, swcHelpers.extends({}, props, {
        title: frame.brand,
        subtitle: frame.code,
        imageUrl: imageUrl
    }));
};

export { FrameInformationContainer as default };
//# sourceMappingURL=FrameInformationContainer.js.map
